// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1u5jc","list":"BalanceDue_list__3CQlQ","listRow":"BalanceDue_listRow__1r55R","total":"BalanceDue_total__20yAM"};